import React from "react";

export type FolderNode = {
  name: string;
  path: string;
  children: FolderNode[];
};

export function toggleFolderExpansion(expanded: ReadonlySet<string>, path: string) {
  const next = new Set(expanded);
  if (next.has(path)) next.delete(path);
  else next.add(path);
  return next;
}

export function FolderTree({
  node,
  current,
  expanded,
  onSelect,
  onToggle,
  root = false,
}: {
  node: FolderNode;
  current: string;
  expanded: ReadonlySet<string>;
  onSelect: (path: string) => void;
  onToggle: (path: string) => void;
  root?: boolean;
}) {
  const hasChildren = node.children.length > 0;
  const isExpanded = root || expanded.has(node.path);

  function activate() {
    onSelect(node.path);
    if (!root && hasChildren) onToggle(node.path);
  }

  return (
    <div className={root ? "folder-root" : "folder-branch"}>
      <button
        className={current === node.path ? "selected" : ""}
        aria-expanded={hasChildren ? isExpanded : undefined}
        onClick={activate}
      >
        <span className={hasChildren ? "folder-chevron" : "folder-leaf"} aria-hidden="true">
          {root ? "▣" : hasChildren ? (isExpanded ? "▾" : "▸") : "•"}
        </span>
        <span>{root ? "All files" : node.name}</span>
      </button>
      {isExpanded && node.children.map(child => (
        <FolderTree
          key={child.path}
          node={child}
          current={current}
          expanded={expanded}
          onSelect={onSelect}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
}
